/* Commercial hub — sticky section nav: freeze lives in commercial-dashboard.css
   (.cml-navbar). This wires the scroll-spy (active tab, class "is-on" per the
   existing CSS) + follow (auto-center the active tab in the nav's horizontal
   scroll). */
(function () {
  'use strict';
  var nav = document.querySelector('[data-cml-sect-nav]');
  if (!nav || !('IntersectionObserver' in window)) return;

  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  var sections = links
    .map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); })
    .filter(Boolean);
  if (!sections.length) return;

  var byId = {};
  links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var a = byId[e.target.id];
        links.forEach(function (l) { l.classList.remove('is-on'); });
        if (a) {
          a.classList.add('is-on');
          a.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    });
  }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });

  sections.forEach(function (s) { obs.observe(s); });
})();
